import React from "react";
import Carousel from "../components/Carousel";
import { MapCertificates } from "../components/MapCertificates";

const Certificates = () => {
  return (
    <React.Fragment>
      <Carousel />
      <MapCertificates />
    </React.Fragment>
  );
};
export default Certificates;
